/**
 * WizCalendar 日历组件
 * @author jzhu
 * @date 2020-06-02
 */

import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col, Button, Tooltip, Select } from 'antd'
import utils from './utils'
import './style/index.less'
import classNames from 'classnames'
import { component_tool } from '@/tool'
const { WizComponent } = component_tool

const SHOW_ALL = 'all'      //展示所有
const SHOW_LAST = 'last'    //展示当前月及上月
const SHOW_SAME = 'same'    //展示当前月
const SHOW_NEXT = 'next'    //展示当前月及下月
const SHOW_DAYS = [SHOW_ALL, SHOW_LAST, SHOW_SAME, SHOW_NEXT]

const DISABLED_NONE = 'none'        //无禁用
const DISABLED_WEEKEND = 'weekend'  //禁用周末
const DISABLED_AFTER = 'after'      //禁用当日之后
const DISABLED_BEFORE = 'before'    //禁用当日之前
const DISABLED_TYPE = [DISABLED_NONE, DISABLED_WEEKEND, DISABLED_AFTER, DISABLED_BEFORE]

class WizCalendar extends WizComponent {
    constructor(props) {
        super(props)
        let { today } = this.props
        let year = today.getFullYear()
        let month = today.getMonth() + 1
        let day = today.getDate()
        this.state = {
            today: { year, month, day },
            selected: { year, month, day },
            mouse: {},
            show: { year, month }
        }
    }

    propsAndStateOnChange = {
        show: this._stateShowOnChange.bind(this),
        selected: this._stateSelectedOnChange.bind(this),
        today: this._todayOnChange.bind(this)
    }

    _stateShowOnChange(nextProps, nextState) {
        let { year, month } = nextState.show
        let { day } = this.state.selected
        nextState.selected = { year, month }
        let maxDay = utils.monthDays(year, month)
        nextState.selected.day = day <= maxDay ? day : maxDay
        if (this.state.show.year !== year || this.state.show.month !== month) {
            this._onPanelChange({ year, month }) 
        }
        return true
    }

    _stateSelectedOnChange(nextProps, nextState) {
        let { year, month } = nextState.selected
        nextState.show = { year, month }
        if (this.state.show.year !== year || this.state.show.month !== month) {
            this._onPanelChange({ year, month }) 
        }
        return true
    }

    _todayOnChange(nextProps, nextState) {
        let today = nextProps.today
        let year = today.getFullYear()
        let month = today.getMonth() + 1
        let day = today.getDate()
        nextState.today = { year, month, day }
        return true
    }

    _onPanelChange(show) {
        if (this.props.onPanelChange) {
            this.props.onPanelChange(show)
        }
    }

    _onLast = () => {
        let { year, month } = this.state.show
        let lastMonth = utils.lastMonth(year, month)
        this.setState({ show: { ...lastMonth } })
    }

    _onNext = () => {
        let { year, month } = this.state.show
        let nextMonth = utils.nextMonth(year, month)
        this.setState({ show: { ...nextMonth } })
    }

    _onToday = () => {
        let { year, month, day } = this.state.today
        this.setState({ selected: { year, month, day }, show: { year, month } })
    }

    _onDate = (date) => {
        let { year, month, day } = date
        this.setState({ selected: { year, month, day }, show: { year, month } })
        if (this.props.onSelect) {
            this.props.onSelect(date)
        }
    }

    _onMouseOver = (date) => {
        this.setState({ mouse: date })
    }

    _onMouseOut = (date) => {
        this.setState({ mouse: {} })
    }

    _onSelectChange = (value, option, key) => {
        this.setState({ show: { ...this.state.show, [key]: value } })
    }

    _renderSelect = (type) => {
        let { year, month } = this.state.show
        let same
        let options = []
        if (type === 'year') {
            same = year
            let i = -10
            while (i <= 10) {
                let value = same + i
                options.push(<Select.Option key={value} value={value} title={value + '年'}>{value + '年'}</Select.Option>)
                i++
            }
        } else {
            same = month
            let i = 1
            while (i <= 12) {
                options.push(<Select.Option key={i} value={i} title={i + '月'}>{i + '月'}</Select.Option>)
                i++
            }
        }
        return (
            <Select key={'select_' + type} className={'header-select-' + type} value={same} onChange={(value, option) => this._onSelectChange(value, option, type)}>
                {options}
            </Select>
        )
    }

    _renderHeader = () => {
        let { year, month } = this.state.show
        if (this.props.renderHeader) {
            return this.props.renderHeader(year, month)
        }
        return (
            <div>
                <Row className='header-row' type='flex' justify='center'>
                    <Col className='header-col' span={5}>
                        <div>
                            <Button title='上月' icon='left' onClick={() => this._onLast()} />
                            <Button title='今天' icon='calendar' onClick={() => this._onToday()} />
                            <Button title='下月' icon='right' onClick={() => this._onNext()} />
                        </div>
                    </Col>
                    <Col className='header-col' span={12}>
                        <div className='header-title'>
                            {year + '年' + month + '月'}
                        </div>
                    </Col>
                    <Col className='header-col' span={5}>
                        {this._renderSelect('year')}
                        {this._renderSelect('month')}
                    </Col>
                </Row>
            </div>
        )
    }

    _renderWeekday = (item) => {
        if (this.props.renderWeekday) {
            this.props.renderWeekday(item)
        }
        return (
            <div className='calendar-weekday'>
                <div className='calendar-text'>
                    {item}
                </div>
            </div>
        )
    }

    _renderWeekHeader = () => {
        let cols = []
        this.props.weekTitle.forEach(item => {
            cols.push(<Col key={'header_' + item} span={3}>{this._renderWeekday(item)}</Col>)
        })
        return (
            <Row type='flex' justify='center'>{cols}</Row>
        )
    }

    _lastMonthDates = (year, month) => {
        let lastMonth = utils.lastMonth(year, month)
        let lastDays = utils.monthDays(lastMonth.year, lastMonth.month)
        let startWeekday = utils.monthStartWeekday(year, month)
        let result = []
        while (startWeekday > 0) {
            let date = { ...lastMonth, day: lastDays - startWeekday + 1 }
            date.none = [SHOW_ALL, SHOW_LAST].includes(this.props.showDays) ? false : true
            result.push(date)
            startWeekday--
        }
        return result
    }

    _sameMonthDates = (year, month) => {
        let days = utils.monthDays(year, month)
        let result = []
        for (let i = 1; i <= days; i++) {
            result.push({ year, month, day: i })
        }
        return result
    }

    _nextMonthDates = (year, month) => {
        let nextMonth = utils.nextMonth(year, month)
        let endWeekday = utils.monthEndWeekday(year, month)
        let result = []
        let i = 1
        while (endWeekday < 6) {
            let date = { ...nextMonth, day: i }
            date.none = [SHOW_ALL, SHOW_NEXT].includes(this.props.showDays) ? false : true
            result.push(date)
            endWeekday++
            i++
        }
        return result
    }

    _renderDateCell = (info) => {
        if (this.props.renderDateCell) {
            return this.props.renderDateCell(info)
        }
    }

    _renderDay = (data) => {
        let { date, isWeekend } = data
        let { year, month, day, none } = date
        let prefixCls = 'calendar-day'
        let _class = prefixCls

        let isToday = utils.equalsObjProperty(date, this.state.today)
        let isAfter = utils.isAfterDate(this.state.today, date)
        let isBefore = !isToday && !isAfter
        let isSelected = utils.equalsObjProperty(date, this.state.selected)

        let info = {
            date: { year, month, day },
            status: { isToday, isBefore, isAfter, isSelected, isWeekend }
        }

        if (this.props.renderDate) {
            let result = this.props.renderDate(info)
            if (result !== false) {
                return result
            }
        }

        if (none) {
            return <div className={_class} />
        }

        let showDay = day < 10 ? '0' + day : day
        let showMonth = month < 10 ? '0' + month : month

        if (isToday) {
            _class = classNames(_class, 'today')
        }

        if (this.props.disabled !== DISABLED_NONE) {
            let renderDisabled = false
            if (this.props.disabled === DISABLED_WEEKEND) {
                if (isWeekend) {
                    if (isToday) {
                        _class = classNames(_class, 'disabled-day')
                        renderDisabled = true
                    } else {
                        _class = classNames(_class, 'disabled-day')
                        renderDisabled = true
                    }
                }
            } else {
                if ((isAfter && this.props.disabled === DISABLED_AFTER)
                    || (!isAfter && !isToday && this.props.disabled === DISABLED_BEFORE)) {
                    _class = classNames(_class, 'disabled-day')
                    renderDisabled = true
                }
            }
            if (renderDisabled) {
                return (
                    <div className={_class}>
                        <div className='date'>
                            <div className='day'>
                                {showDay}
                            </div>
                            <div className='cell'>
                                {this._renderDateCell(info)}
                            </div>
                        </div>
                    </div>
                )
            }
        }

        if (isSelected) {
            _class = classNames(_class, 'selected')
        } else {
            let isMouse = utils.equalsObjProperty(date, this.state.mouse)
            if (isMouse) {
                _class = classNames(_class, 'mouse')
            }
        }
        let title = year + '年' + showMonth + '月' + showDay + '日'
        return (
            <Tooltip title={title} {...this.props.tooltipProps}>
                <div
                    className={_class}
                    onClick={() => this._onDate(date)}
                    onMouseOver={() => this._onMouseOver(date)}
                    onMouseOut={() => this._onMouseOut(date)}
                >
                    <div className='date'>
                        <div className='day'>
                            {showDay}
                        </div>
                        <div className='cell'>
                            {this._renderDateCell(info)}
                        </div>
                    </div>
                </div>
            </Tooltip>
        )
    }


    _renderDayItem = (data, index) => {
        let { year, month, day } = data.date
        return <Col key={year + '_' + month + '_' + day} span={3}>{this._renderDay(data, index)}</Col>
    }

    _renderMonthDaysRow = (row, i) => {
        let days = []
        for (let index = 0; index < row.length; index++) {
            let date = row[index]
            let isWeekend = index === 0 || index === row.length - 1
            let data = { date, isWeekend }
            days.push(this._renderDayItem(data, index))
        }
        return <Row key={'row_' + i} type='flex' justify='center'>{days}</Row>
    }

    _renderMonthDays = () => {
        let { year, month } = this.state.show
        let dates = []
        dates = dates.concat(this._lastMonthDates(year, month))
        dates = dates.concat(this._sameMonthDates(year, month))
        dates = dates.concat(this._nextMonthDates(year, month))
        let showDays = []
        if (dates.length) {
            let row = []
            let index = 1
            dates.forEach(date => {
                row.push(date)
                if (row.length % 7 === 0) {
                    showDays.push(this._renderMonthDaysRow(row, index))
                    row = []
                    index++
                }
            })
        }
        return showDays
    }

    _renderMonth = () => {
        return (
            <div className='calendar-month'>
                {this._renderWeekHeader()}
                {this._renderMonthDays()}
            </div>
        )
    }

    _renderFooter = () => {
        if (this.props.renderFooter) {
            this.props.renderFooter()
        }
    }

    render() {
        return (
            <div className='wizCalendar'>
                <div className='calendar'>
                    {this._renderHeader()}
                    {this._renderMonth()}
                    {this._renderFooter()}
                </div>
            </div>
        )
    }
}

WizCalendar.defaultProps = {
    today: new Date(),
    weekTitle: ['日', '一', '二', '三', '四', '五', '六'],
    showDays: SHOW_ALL,
    disabled: DISABLED_NONE,
    tooltipProps: {}
}

WizCalendar.propTypes = {
    /**
     * @description 当前日期 
     * @default new Date()
     */
    today: PropTypes.instanceOf(Date),
    /**
     * @description 自定义周文字展示（从周日开始）
     * @default ['日', '一', '二', '三', '四', '五', '六']
     */
    weekTitle: PropTypes.array,
    /**
     * @description 日期展示类型
     */
    showDays: PropTypes.oneOf(SHOW_DAYS),
    /**
     * @description 日期禁用类型
     */
    disabled: PropTypes.oneOf(DISABLED_TYPE),
    /**
     * @description 自定义周单元格渲染
     * @param {*} weekday
     */
    renderWeekday: PropTypes.func,
    /**
     * @description 自定义日期单元格渲染 
     * @param {*} 
     * @return 如果返回false则使用组件默认渲染单元格
     */
    renderDate: PropTypes.func,
    /**
     * @description 自定义日期单元格追加渲染内容
     */
    renderDateCell: PropTypes.func,
    /**
     * @description 自定义文字提示属性
     */
    tooltipProps: PropTypes.object,
    /**
     * @description 日期面板变化回调
     */
    onPanelChange: PropTypes.func,
    /**
     * @description 点击选择日期回调
     * @param {*} date { year, month, day }	
     */
    onSelect: PropTypes.func,
}


WizCalendar.SHOW_ALL = SHOW_ALL
WizCalendar.SHOW_LAST = SHOW_LAST
WizCalendar.SHOW_SAME = SHOW_SAME
WizCalendar.SHOW_NEXT = SHOW_NEXT
WizCalendar.DISABLED_NONE = DISABLED_NONE
WizCalendar.DISABLED_WEEKEND = DISABLED_WEEKEND
WizCalendar.DISABLED_AFTER = DISABLED_AFTER
WizCalendar.DISABLED_BEFORE = DISABLED_BEFORE
WizCalendar.Utils = utils

export default WizCalendar